import React from "react";

export default class RightPane extends React.Component {
	render() {
		return (
			<div className="rightpane"><div>Right pane</div></div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/scripts/components/rightpane/RightPane.jsx
 **/